import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "main-panel" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "result-title" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "order-grid" }
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "section" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "section" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "section" }
const _hoisted_15 = ["for"]
const _hoisted_16 = ["id", "name", "value"]
const _hoisted_17 = {
  key: 0,
  for: "freeEntries"
}
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "content" }
const _hoisted_21 = { class: "section" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderDots = _resolveComponent("LoaderDots")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.order)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", null, "User ID: " + _toDisplayString(_ctx.order.userId), 1),
            _createElementVNode("a", {
              class: "user",
              href: `/users/${_ctx.order.userId}`
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("h1", null, [
                _createTextVNode(" User Details "),
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 512 512"
                }, [
                  _createElementVNode("path", { d: "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l82.7 0L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3l0 82.7c0 17.7 14.3 32 32 32s32-14.3 32-32l0-160c0-17.7-14.3-32-32-32L320 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z" })
                ])
              ], -1)
            ]), 8, _hoisted_4)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Order Details", -1)),
                _cache[3] || (_cache[3] = _createElementVNode("label", { for: "orderid" }, [
                  _createElementVNode("strong", null, "Order ID")
                ], -1)),
                _createElementVNode("input", {
                  id: "orderid",
                  name: "orderid",
                  disabled: "",
                  value: _ctx.order.orderId,
                  readonly: ""
                }, null, 8, _hoisted_8),
                _cache[4] || (_cache[4] = _createElementVNode("label", { for: "date" }, [
                  _createElementVNode("strong", null, "Order Date")
                ], -1)),
                _createElementVNode("input", {
                  id: "date",
                  name: "date",
                  disabled: "",
                  value: _ctx.order.createDate,
                  readonly: ""
                }, null, 8, _hoisted_9)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[5] || (_cache[5] = _createElementVNode("h3", null, "Entries", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.entrySummaries, (entrySummary, index) => {
                  return (_openBlock(), _createElementBlock("input", {
                    key: index,
                    class: "entrySummary",
                    name: "entrySummaries",
                    disabled: "",
                    value: entrySummary,
                    readonly: ""
                  }, null, 8, _hoisted_12))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Payment Details", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.paymentDetails, (payment, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "paymentDetail"
                  }, [
                    _createElementVNode("label", {
                      for: `payment-${index}`,
                      class: "payment-label"
                    }, _toDisplayString(payment.paymentMethod.toUpperCase()), 9, _hoisted_15),
                    _createElementVNode("input", {
                      id: `payment-${index}`,
                      name: `payment-${index}`,
                      disabled: "",
                      value: `£${payment.amount.toFixed(2)}`,
                      readonly: "",
                      class: "payment-input"
                    }, null, 8, _hoisted_16)
                  ]))
                }), 128)),
                (_ctx.order.freeEntries > 0)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_17, _cache[6] || (_cache[6] = [
                      _createElementVNode("strong", null, "Free Entries", -1)
                    ])))
                  : _createCommentVNode("", true),
                (_ctx.order.freeEntries > 0)
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 1,
                      id: "freeEntries",
                      name: "freeEntries",
                      disabled: "",
                      value: _ctx.order.freeEntries.toString(),
                      readonly: ""
                    }, null, 8, _hoisted_18))
                  : _createCommentVNode("", true),
                _cache[8] || (_cache[8] = _createElementVNode("label", { for: "total" }, [
                  _createElementVNode("strong", null, "Total")
                ], -1)),
                _createElementVNode("input", {
                  id: "total",
                  name: "total",
                  disabled: "",
                  value: `£${_ctx.order.totalAmount.toFixed(2)}`,
                  readonly: ""
                }, null, 8, _hoisted_19)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("button", {
                  disabled: _ctx.isSubmittingUpdateDetails,
                  class: "btn",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendOrderEmail && _ctx.sendOrderEmail(...args)))
                }, [
                  (!_ctx.isSubmittingUpdateDetails)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Send Confirmation Email"))
                    : _createCommentVNode("", true),
                  (_ctx.isSubmittingUpdateDetails)
                    ? (_openBlock(), _createBlock(_component_LoaderDots, { key: 1 }))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_22)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}